import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { fmtSEK } from "./format";

export default function AmountCell({ value, locked, missing, canEdit, onCommit, testId, muted }) {
  const [draft, setDraft] = useState(null);
  const [state, setState] = useState("");

  if (locked || !canEdit) {
    return (
      <td className={`px-1 py-1 text-right ${locked ? "bg-slate-100/70" : ""}`} data-testid={testId}>
        <div className="h-8 flex items-center justify-end gap-1 pr-1.5 text-sm">
          {missing && <AlertTriangle className="h-3 w-3 text-[#B45309]" />}
          <span className={muted ? "text-slate-400" : "text-slate-800 font-medium"}>{fmtSEK(value)}</span>
        </div>
      </td>
    );
  }
  const commit = async () => {
    if (draft == null) return;
    const v = draft === "" ? null : Number(draft);
    if (v === (value ?? null)) {
      setDraft(null);
      return;
    }
    if (draft !== "" && Number.isNaN(v)) {
      toast.error("Enter a valid number");
      setDraft(null);
      return;
    }
    setState("saving");
    const ok = await onCommit(v);
    setState(ok ? "saved" : "error");
    if (ok) setDraft(null);
    setTimeout(() => setState(""), 1200);
  };
  return (
    <td className="px-1 py-1" data-testid={testId}>
      <div className="relative">
        <input
          type="number"
          className={`h-8 w-full text-right text-sm rounded-md border bg-white outline-none pr-1.5 transition-colors
            ${state === "error" ? "border-[#B91C1C]" : "border-transparent hover:border-slate-300 focus:border-[#0052CC]"}
            ${state === "saved" ? "border-[#047857]" : ""}`}
          value={draft ?? value ?? ""}
          placeholder="—"
          onChange={(e) => setDraft(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
          data-testid={`${testId}-input`}
        />
        {state === "saving" && <Loader2 className="h-3 w-3 animate-spin text-slate-400 absolute right-1.5 top-2.5" />}
      </div>
    </td>
  );
}
